import React from 'react'
import { useTranslation } from 'react-i18next'
// @ts-ignore
import { Retweet } from '@netbasequid/core'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import ActionIconsContainer from './ActionIconsContainer'

type RetweetIconProps = {
  postId: string
  displayText?: boolean
  iconColor?: string
}

const RetweetIcon = ({ postId, displayText = true, iconColor }: RetweetIconProps) => {
  const { t } = useTranslation()
  const theme = useDisplayTheme() as Theme
  const color = iconColor || sys[theme].text.placeholder

  return (
    <ActionIconsContainer
      tooltipContent={t('retweet')}
      message={displayText ? t('retweet') : ''}
      url={`https://twitter.com/intent/retweet?tweet_id=${postId}`}>
      <Retweet color={color} />
    </ActionIconsContainer>
  )
}

export default RetweetIcon
